export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SHOWMENU = 'SHOWMENU'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js